import { observer } from 'mobx-react-lite';
import 'semantic-ui-css/semantic.min.css';
import {
  Header,
  Icon,
  Form,
  Table,
  Button,
  Select,
  Container,
  Pagination,
  Input,
} from 'semantic-ui-react';
import React, { useEffect, useState } from 'react';
import { useStore } from '../../app/stores/store';
import { adlEmployeeDetails } from '../../app/models/adlData';
import agent from '../../app/api/agent';
import { toast } from 'react-toastify';
import DeleteModal from '../../library/deleteModal';

function AssignReportingHeadHierarchy() {
  const { RestorationStore, ADLtrackingStore } = useStore();
  const [selectPcId, setselectPcid] = useState<
    { key: string; value: string; text: string }[]
  >([]);
  const [selectleadid, setselectleadid] = useState<
    { key: string; value: string; text: string }[]
  >([]);
  const [selectempid, setselectempid] = useState<
    { key: string; value: string; text: string }[]
  >([]);
  const [idDetails, setIdDetails] = useState<any>({});
  const [employeeDetails, setEmployeeDetails] = useState<any>({});
  const [teamNameList, setTeamNameList] = useState<
    { key: string; value: string; text: string }[]
  >([]);
  const [searchEmpId, setSearchEmpId] = useState<string>('');
  const [empId, setEmpId] = useState<string>('');
  const [empList, setempList] = useState<adlEmployeeDetails[]>([]);
  const itemsperPage = 20;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [countData, setcountData] = useState<number>(1);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<string | null>(null);
  const [itemIndexToDelete, setItemIndexToDelete] = useState<number | null>(
    null,
  );

  useEffect(() => {
    RestorationStore.pcEmpIdgets();
    RestorationStore.OperatorEmpid();
    RestorationStore.leadEmpID();
    RestorationStore.teamName();
    // eslint-disable-next-line
  }, []);

  const totalEmployeeCount = async (employeeId:string) => {
    const response = await agent.adltracking.employeeCount(employeeId);
    setcountData(response.data);
  };
  const loadEmployeeDetails = async (page: number, size: number, employeeId: string) => {
    const response = await agent.adltracking.getEmployeedetails(page, size, employeeId);
    setempList(response.data);
    totalEmployeeCount(employeeId);
  };
  // useEffect(() => {
  //   loadEmployeeDetails(currentPage, itemsperPage);
  // }, [currentPage,itemsperPage]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await agent.adltracking.getEmployeedetails(
        currentPage,
        itemsperPage,
        empId
      );
      setempList(response.data);
      totalEmployeeCount(empId);
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, itemsperPage]);

  useEffect(() => {
    const headid = (RestorationStore.pcEmpIdGet || [])?.map((data: string) => {
      return {
        key: data,
        text: data,
        value: data,
      };
    });
    setselectPcid(headid);
  }, [RestorationStore.pcEmpIdGet]);

  useEffect(() => {
    const operatorid = (RestorationStore.operatorEmpIdGet || [])?.map(
      (data: string) => {
        return {
          key: data,
          text: data,
          value: data,
        };
      },
    );
    setselectempid(operatorid);
  }, [RestorationStore.operatorEmpIdGet]);

  useEffect(() => {
    const leadid = (RestorationStore.leadEmpId || [])?.map((data: string) => {
      return {
        key: data,
        text: data,
        value: data,
      };
    });
    setselectleadid(leadid);
  }, [RestorationStore.leadEmpId]);

  useEffect(() => {
    const teamLists = (RestorationStore.teamList || [])?.map((data: string) => {
      return {
        key: data,
        text: data,
        value: data,
      };
    });
    setTeamNameList(teamLists);
  }, [RestorationStore.teamList, ADLtrackingStore.getallemployeedetails]);
  const billabilityData = [{key: '1', text: 'Yes', value: true},{ key: '2',text: 'No',value: false}];
  const efficiyData = [
    {key: '1', text: '15%', value: '15%'},
    { key: '2',text: '30%',value: '30%'},
    { key: '3',text: '45%',value: '45%'},
    { key: '4',text: '50%',value: '50%'},
    { key: '5',text: '75%',value: '75%'},
    { key: '6',text: '100%',value: '100%'},
    { key: '7',text: '110%',value: '110%'},
    { key: '8',text: '120%',value: '120%'},
    { key: '9',text: '130%',value: '130%'},
    { key: '10',text: '140%',value: '140%'},    
    { key: '11',text: '150%',value: '150%'},
  ];
  const machineEfficienyData = [
    {key: '1', text: '10%', value: '10%'},
    { key: '2',text: '20%',value: '20%'},
    { key: '3',text: '30%',value: '30%'},
    { key: '4',text: '40%',value: '40%'},
    { key: '5',text: '50%',value: '50%'},
  ]
  const setDD = async (_e: any, data: any, fieldName: string) => {
    if (data.value?.length > 0) 
      {
          setIdDetails({
            ...idDetails,
            [fieldName]: data.value,
          }); 
          const temp = await RestorationStore.GetempnameFind(data.value);
          setEmployeeDetails({
            ...employeeDetails,
            [fieldName]: temp,
          });
      }
      else if(fieldName==='billability' || fieldName==='billability')
        {
          setIdDetails({
            ...idDetails,
            [fieldName]: data.value,
          }); 
          const temp = await RestorationStore.GetempnameFind(data.value);
          setEmployeeDetails({
            ...employeeDetails,
            [fieldName]: temp,
          });
        }

      
  };
  
  const saveHandler = async () => {
    const isFormValid =
      !!idDetails.empId?.toString().trim() &&
      !!idDetails.leadId?.toString().trim() &&
      !!idDetails.headId?.toString().trim() &&
      !!idDetails.team?.toString().trim();

    if (!isFormValid) {
      toast.error('Please fill all required fields: Employee Id, Lead Id, Head Id, and Team');
      return;
    }
    let payLoad = {
      employee_ID: idDetails['empId'],
      employeeName: employeeDetails['empId'],
      lead: idDetails['leadId'],
      head: idDetails['headId'],
      team: idDetails['team'],
      efficiency:idDetails['efficiency'],
      machine_Efficiency:idDetails['machineEfficiency'],
      billability:idDetails['billability'],
      dof:idDetails['dof'],
      department: idDetails['department'],
    };
    await ADLtrackingStore.assignNewEmployee(payLoad);
    loadEmployeeDetails(currentPage, itemsperPage, empId);
    cancelHandler();
  };

  const modifyHandler = async (employeeData: adlEmployeeDetails) => {
    setIdDetails({
      empId: employeeData.employee_ID,
      leadId: employeeData.lead,
      headId: employeeData.head,
      team: employeeData.team,
      efficiency:employeeData.efficiency,
      machineEfficiency:employeeData.machine_Efficiency,
      billability:employeeData.billability,
      department:employeeData.department
    });
    setEmployeeDetails({
      empId: employeeData.employeeName,
      leadId: employeeData.lead,
      headId: employeeData.head,
      efficiency:employeeData.efficiency,
      machineEfficiency:employeeData.machine_Efficiency,
      billability:employeeData.billability,
      department:employeeData.department
    });
  };
  const cancelHandler = async () => {
    setIdDetails({
      empId: '',
      leadId: '',
      headId: '',
      team: '',
      billability:'',
      department:'',
    });
    setEmployeeDetails({
      empId: '',
      leadId: '',
      headId: '',
      efficiency:'',
      machineEfficiency:'',
      department:'',
    });
  };

  const toggleConfirmationModal = (itemId: string, index: number) => {
    setItemToDelete(itemId);
    setItemIndexToDelete(index);
    setShowConfirmation(true);
  };

  const deleteHandler = async (employeeID: string, index: number) => {
    try {
      await ADLtrackingStore.deleteEmployeeReportingHead(employeeID);
      toast.success('Sucessfully Remove Employee');
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };
  const confirmDelete = async () => {
    if (itemToDelete !== null && itemIndexToDelete !== null) {
      try {
        await deleteHandler(itemToDelete, itemIndexToDelete);
        toast.success('Successfully Removed Employee');
        loadEmployeeDetails(currentPage, itemsperPage, empId);
      } catch (error) {
        toast.error('Something went wrong. Please try again!');
      }
      setShowConfirmation(false); // Close the modal
    }
  };

  const handleSearch = (empId: string) => {
    setEmpId(empId);
    setCurrentPage(1);
    loadEmployeeDetails(1, itemsperPage, empId);
  };

  return (
    <>
      {showConfirmation && (
        <DeleteModal
          text={`Are you sure you want to remove Employee ${itemToDelete}?`}
          closeHandler={() => setShowConfirmation(false)}
          deleteHandler={confirmDelete}
          isModalOpen={showConfirmation}
        />
      )}
      <div className="title-wise-table">
        <div
          className="new-report-form-wrapper"
          style={{ width: '90%', margin: 'auto' }}
        >
          <Header>Assign Reporting Head</Header>
          <Container fluid color="yellow">
            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  id=""
                  label="Employee Id"
                  control={Select}
                  filter
                  Selection
                  search
                  options={selectempid}
                  onChange={(_event: any, data: any) =>
                    setDD(_event, data, 'empId')
                  }
                  value={idDetails['empId']}
                  placeholder="Employee Id"
                />
                <Form.Field
                  id=""
                  label="Lead Id"
                  control={Select}
                  filter
                  Selection
                  search
                  options={selectleadid}
                  onChange={(_event: any, data: any) =>
                    setDD(_event, data, 'leadId')
                  }
                  value={idDetails['leadId']}
                  placeholder="Lead Id"
                  required
                />

                <Form.Field
                  id=""
                  label="Head Id"
                  control={Select}
                  filter
                  Selection
                  search
                  options={selectPcId}
                  onChange={(_event: any, data: any) =>
                    setDD(_event, data, 'headId')
                  }
                  value={idDetails['headId']}
                  placeholder="Head Id"
                  required
                />

                <Form.Field
                  id=""
                  label="Team"
                  control={Select}
                  filter
                  Selection
                  search
                  allowAdditions
                  options={teamNameList}
                  onAddItem={(e: React.SyntheticEvent, { value }: any) => {
                    const newOption = { key: value, text: value, value: value };
                    setTeamNameList((prev) => [...prev, newOption]);
                  }}
                  onChange={(_event: any, data: any) =>
                    setDD(_event, data, 'team')
                  }
                  value={idDetails['team']}
                  placeholder="Team"
                  required
                />

                <Form.Field id="">
                  <Form.Input
                    fluid
                    label="Department"
                    value={idDetails['department']}
                    placeholder="Department"
                    onChange={(_event: any, data: any) =>
                      setDD(_event, data, 'department')
                    }
                  />
                </Form.Field>
                {/* <Form.Field id="">
                  <Form.Input
                    fluid
                    label="Efficiency"
                    value={employeeDetails['efficiency']}
                    // disabled
                    placeholder="Please Select efficiency"
                    onChange={(_event: any, data: any) =>
                      setDD(_event, data, 'efficiency')
                    }
                  /> */}
                {/* </Form.Field> */}
                <Form.Field
                  id=""
                  label="Efficiency"
                  control={Select}
                  filter
                  Selection
                  search
                  options={efficiyData}
                  onChange={(_event: any, data: any) =>
                    setDD(_event, data, 'efficiency')
                  }
                  value={idDetails['efficiency']}
                  placeholder="Please Select Efficiency"
                />

              </Form.Group>
              <Form.Group widths="equal">
              <Form.Field
                  id=""
                  label="Machine Efficiency"
                  control={Select}
                  filter
                  Selection
                  search
                  options={machineEfficienyData}
                  onChange={(_event: any, data: any) =>
                    setDD(_event, data, 'machineEfficiency')
                  }
                  value={idDetails['machineEfficiency']}
                  placeholder="Please Select Efficiency"
                />
                <Form.Field id="">
                  <Form.Input
                    fluid
                    label="Employee name"
                    value={employeeDetails['empId']}
                    disabled
                    placeholder="Please Select Employee ID"
                    readOnly
                  />
                </Form.Field>
                <Form.Field id="">
                  <Form.Input
                    fluid
                    label="Lead name"
                    value={employeeDetails['leadId']}
                    disabled
                    placeholder="Please Select Lead ID"
                    readOnly
                  />
                </Form.Field>
                <Form.Field id="">
                  <Form.Input
                    fluid
                    label="Head name"
                    value={employeeDetails['headId']}
                    disabled
                    placeholder="Please Select Head ID"
                    readOnly
                  />
                </Form.Field>
                <Form.Field
                  id=""
                  label="Billable"
                  control={Select}
                  filter
                  Selection
                  search
                  options={billabilityData}
                  onChange={(_event: any, data: any) =>
                    setDD(_event, data, 'billability')
                  }
                  value={idDetails['billability']}
                  placeholder="Billable"
                />
              </Form.Group>
              <Form.Group style={{ justifyContent: 'end' }}>
                <Form.Field id="">
                  {/* <label style={{color:'white'}}> Click Here </label> */}
                  <br />
                  <Button.Group>
                    <Button onClick={cancelHandler}>Cancel</Button>
                    <Button.Or />
                    <Button positive onClick={saveHandler}>
                      Save
                    </Button>
                  </Button.Group>
                </Form.Field>
              </Form.Group>
            </Form>
          </Container>
        </div>
        <br />
        <div
          className="new-report-form-wrapper"
          style={{ width: '90%', margin: 'auto' }}
        >
          <Header>List of Employee Details</Header>
          <Input
            placeholder="Please Enter Employee Id"
            style={{ width: '250px' }}
            value={searchEmpId}
            onChange={(e) => {
              const value = e.target.value;
              setSearchEmpId(value);
              
              if (value === '') {
                handleSearch('');
              }
            }}
            onKeyDown={(e:any) => {
              if (e.key === 'Enter') {
                handleSearch(searchEmpId);
              }
            }}
            icon={{
              name: 'search',
              link: true,
              onClick: () => handleSearch(searchEmpId),
            }}
          />
          <Table singleLine>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Employee Id</Table.HeaderCell>
                <Table.HeaderCell>Employee Name</Table.HeaderCell>
                <Table.HeaderCell>Lead Id</Table.HeaderCell>
                <Table.HeaderCell>Head Id</Table.HeaderCell>
                <Table.HeaderCell>Team</Table.HeaderCell>
                <Table.HeaderCell>Department</Table.HeaderCell>
                <Table.HeaderCell>Efficiency</Table.HeaderCell>
                <Table.HeaderCell>Machine Efficiency</Table.HeaderCell>
                <Table.HeaderCell>Billable</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {empList.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={7} textAlign="center">
                    Data is currently unavailable..{' '}
                  </Table.Cell>
                </Table.Row>
              )}
              {empList.length !== 0 &&
                empList.map((Items, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{Items.employee_ID}</Table.Cell>
                    <Table.Cell>{Items.employeeName}</Table.Cell>
                    <Table.Cell>{Items.lead}</Table.Cell>
                    <Table.Cell>{Items.head}</Table.Cell>
                    <Table.Cell>{Items.team}</Table.Cell>
                    <Table.Cell>{Items.department}</Table.Cell>
                    <Table.Cell>{Items.efficiency}</Table.Cell>
                    <Table.Cell>{Items.machine_Efficiency ? `${Items.machine_Efficiency}` : '0%'}</Table.Cell>
                    <Table.Cell>{Items.billability ? 'Yes':'No'}</Table.Cell>
                    <Table.Cell textAlign="center">
                      <Button.Group>
                        <Button onClick={() => modifyHandler(Items)}>
                          {' '}
                          <Icon name="edit" />
                        </Button>
                        <Button.Or />
                        <Button
                          onClick={() =>
                            toggleConfirmationModal(Items.employee_ID, index)
                          }
                        >
                          <Icon name="trash" />
                        </Button>
                      </Button.Group>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>

          <div>
            <Pagination
              activePage={currentPage || 1}
              totalPages={Math.ceil(countData / itemsperPage)}
              onPageChange={
                (_event, data) => setCurrentPage(Number(data.activePage) || 1) // Convert the activePage to a number
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default observer(AssignReportingHeadHierarchy);


